import type { DetailedHTMLProps, FC, HTMLAttributes, ReactNode } from 'react';
import { ChakraProvider, ThemeProvider } from '@chakra-ui/react';
import { CSSReset, QTheme } from '..';
import { ChakraContainerProvider } from '../hooks/chakraContainer/chakraContainer';

declare global {
  // eslint-disable-next-line @typescript-eslint/no-namespace
  namespace JSX {
    interface IntrinsicElements {
      'chakra-scope': DetailedHTMLProps<
        HTMLAttributes<HTMLElement>,
        HTMLElement
      >;
    }
  }
}

export const QualioQThemeProvider: FC<{ children?: ReactNode }> = ({
  children,
}) => (
  <chakra-scope>
    <ChakraProvider theme={QTheme} resetCSS={false}>
      <ThemeProvider theme={QTheme}>
        <ChakraContainerProvider>
          <CSSReset />
          {children}
        </ChakraContainerProvider>
      </ThemeProvider>
    </ChakraProvider>
  </chakra-scope>
);
